module.exports = __webpack_public_path__ + "img/Intelligence-on@3x.34e2809a.png";